export const HeaderBlock = () => {
    return(
        <>
            <div className="headerBlock">
                Pay early and get rewarded
            </div>
            <div className="headerText">
                1. Connect to Sepolia<br />
                2. Make sure you have Sepolia ETH in your wallet<br />
                3. Use the faucet button to get testnet USDC<br />
                4. Enter the invoice details<br />
                5. Increase your allowance if needed<br />
                6. Pay the invoice and earn<br />
            </div>
        </>
    )
}